// extracted by mini-css-extract-plugin
export default {"discover":"BusinessDiscover_discover__lgyZC","discoverContent":"BusinessDiscover_discoverContent__ZrrDH"};